// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentMethodBox_root__sTW0g","logos":"PaymentMethodBox_logos__YuChL","logo":"PaymentMethodBox_logo__MdX8e","label":"PaymentMethodBox_label__7VuWF"};